module.exports = __webpack_public_path__ + "ba50f3a6cb88cd96ebd091560f44728a.jpg";